var map = {
	"./Aboubakar.jpeg": 930,
	"./Amadou.jpeg": 931,
	"./Aymard.jpeg": 932,
	"./Bakary.jpeg": 933,
	"./Daniel.jpeg": 934,
	"./Fabrice.jpeg": 935,
	"./Hassan.jpg": 936,
	"./Konoufo.jpg": 937,
	"./Marianne.jpeg": 938,
	"./Ochou.jpeg": 939,
	"./Olivier.jpeg": 940
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 929;


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team nonrecursive ^\.\/.*$
// module id = 929
// module chunks = 3